import { useEffect, useRef } from 'react'
import { useOutletContext, useParams } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import { NotificationTypes, addNotification } from '../../../../state/actions/notificationActions.js'
import { fetchCanGrantGroupList } from '../../../../state/actions/groupActions'

import { canGrantGroupListSignal } from '../../../../state/signals/groupSignals.js'

import { UserRoles, UserTypes } from '../../../../utils/constants.js'
import { assembleEntity, naturalValidateInput, validateForm, validateInput } from '../../../../utils/form'
import { REGEX_VALID_EMAIL_ADDRESS } from '../../../../utils/RegularExpressions'

function AddGroupsModal({ showSignal, cancelAdd, businessEntity, handleSubmit, selectedGroups, userGroupsSignal }) {
    const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()
    const selectedGroupsSignal = useSignal([])

    useEffect(() => {
        fetchCanGrantGroupList(businessEntity, config, accessToken)
    }, [businessEntity, config, accessToken])

    function GroupsRows({ items }) {
        if (!items || !items.length)
            return <div>No Groups to Display</div>

        let rows = []
        const userGroupIds = new Set(userGroupsSignal.map(g => g.id));
        const groupsNotInUserGroups = items.filter(g => !userGroupIds.has(g.id));
        if (!groupsNotInUserGroups || !groupsNotInUserGroups.length)
            return <div>There are no groups that can be added.</div>
        groupsNotInUserGroups.map((item, idx) => (
            rows.push(<GroupsRow item={item} key={idx} />)
        ))
        return rows
    }

    function GroupsRow({ item }) {
        return (
            <Form.Check
                type="checkbox"
                id={`default-checkbox-${item.id}`}
                value={`${item.id}`}
                label={item.name}
                onChange={() => selectedGroups.push(`${item.id}`)}
            />)
    }

    return (
        <Modal
            show={showSignal.value}
            onHide={cancelAdd}
            backdrop="static"
        >
            <Modal.Header closeButton className="panel-heading">
                <Modal.Title className="panel-title">Add Groups</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group as={Form.Row} className="mb-3" controlId="formGroupGroups">
                        <GroupsRows items={canGrantGroupListSignal.value} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="panel-footer col-xs-12">
                <div className='pull-right'>
                    <Button className="btn btn-md btn-default" style={{ marginRight: '1rem' }} onClick={cancelAdd}>Cancel</Button>
                    <Button className="btn btn-md btn-primary" onClick={handleSubmit}>Add</Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default AddGroupsModal